import {AfterViewInit, Component, Inject, NgZone, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';


@Component({
  selector: 'app-chart-gyr',
  templateUrl: './chart-gyr.component.html',
  styleUrls: ['./chart-gyr.component.css']
})
export class ChartGyrComponent implements OnInit, AfterViewInit {


  constructor(private zone: NgZone) {}

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.createCharts();
  }

  createCharts() {
    this.zone.runOutsideAngular(() => {
      am4core.useTheme(am4themes_animated);
      const chart = am4core.create('chart-gyr', am4charts.PieChart);
      chart.data = [
        { category: 'зеленый', value: 30, color: am4core.color('#2fba88') },
        { category: 'жолтый', value: 45, color: am4core.color('#f4b740') },
        { category: 'красный', value: 25, color: am4core.color('#f84051') }
      ];

      const series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = 'value';
      series.dataFields.category = 'category';
      series.dataFields.hidden = 'hidden';
      series.labels.template.disabled = true;
      series.ticks.template.disabled = true;
      series.slices.template.propertyFields.fill = 'color';
      chart.innerRadius = am4core.percent(40);

      chart.legend = new am4charts.Legend();
      chart.legend.position = 'right';
    });
  }
}
